export class DocumentSettingsData {
  esigningEmailRecipients: EsigningEmailRecipients;

  constructor(data: Partial<DocumentSettingsData> = {}) {
    this.esigningEmailRecipients = data.esigningEmailRecipients ?? EsigningEmailRecipients.DoNotSend;
  }
}

export enum EsigningEmailRecipients {
  DoNotSend,
  SenderOnly,
  RecipientsOnly,
  SenderAndRecipients
}
